import React, { memo, useState } from "react";
import { Button, CloseButton, Col, Form, Modal, Row } from "react-bootstrap";
import '../../../../common/styles/form.scss'
import '../../../../common/styles/form.scss'
export const VerticallyModal = memo(({ showModal, titulo, mensaje, hideModal, radicacion } : any) => {

  const CerrarModal = () => {
    
    if(titulo == '¡Gracias por contactarte con nosotros!'){
      window.location.reload()
      showModal (false)
    }
     showModal (false)
  };

  const Aceptar = () => {
    
     
    if(titulo == '¡Gracias por contactarte con nosotros!'){
      window.location.reload()
      showModal (false)
    }
    else{
      showModal (false)
    }
   
  };


    return (  
        <Modal id='mostrarModal' show={hideModal} 
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        <Modal.Header id='colorLine' closeButton onClick={()=>CerrarModal()}>
          <Modal.Title id='main1'><strong>{titulo}</strong> </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <p className="text-center">
               {mensaje} 
             </p>
             <p className="text-center">
             {radicacion}
             </p>
         
          <Modal.Footer id='colorBorderTop'>
            
           <Button id='btnprimarySa' onClick={() => Aceptar()}
           >Aceptar
           
           </Button>
          
          </Modal.Footer>
        </Modal.Body>
      </Modal>
    
    )
});
